// external
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

// internal
import CustomButton from "components/customComponents/CustomButton";

// styles
import "css/admin/utils/carousel-button-position.scss";

export class CarouselButtonPositionUI extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      t,
      ratio,
      buttonHorizontalPosition,
      buttonVerticalPosition,
      onPositionChange,
    } = this.props;

    return (
      <div className={`editor-carousel-button-position ratio-${ratio}`}>
        <div className="back">
          <i className="material-icons">landscape</i>
        </div>
        <div className="positions-table">
          {["top", "center", "bottom"].map((ver) => (
            <div className="buttons-row" key={ver}>
              {["left", "center", "right"].map((hor) => {
                const selectable = !(
                  hor === buttonHorizontalPosition &&
                  ver === buttonVerticalPosition
                );
                return (
                  <div
                    className={`buttons-col ${selectable ? "selectable" : ""}`}
                    key={hor}
                    onClick={() => {
                      selectable && onPositionChange(hor, ver);
                    }}
                  >
                    {!selectable && (
                      <CustomButton
                        namespace="carousel"
                        className="btn-carousel"
                        isRouterLink={false}
                        style={{
                          color: "#696969",
                          borderColor: "#696969",
                        }}
                      >
                        {t("buttonLabel")}
                      </CustomButton>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

CarouselButtonPositionUI.propTypes = {
  buttonHorizontalPosition: PropTypes.string.isRequired,
  buttonVerticalPosition: PropTypes.string.isRequired,
  ratio: PropTypes.string.isRequired,
  onPositionChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-platform")(CarouselButtonPositionUI);
